export default [
  {
    _name: "CSidebarNav",
    _children: [
      {
        _name: "CSidebarNavItem",
        name: "Dashboard",
        to: "/dashboard",
        icon: "cil-exclamation-circle",
      },
      {
        _name: "CSidebarNavDropdown",
        name: "Profile",
        to: "/dashboard/user-profile",
        icon: "cil-user",
        items: [
          {
            name: "My Profile",
            to: "/dashboard/user-profile",
          },
          {
            name: "Bank Account",
            to: "/dashboard/user-profile_bank",
          },
        ],
      },
      {
        _name: "CSidebarNavItem",
        name: "Recruiting Process",
        to: "/dashboard/recruiting-process",
        icon: "cil-sitemap",
      },
      {
        _name: "CSidebarNavItem",
        name: "Job Pool",
        to: "/dashboard/job-pool",
        icon: "cil-briefcase",
      },
      {
        _name: "CSidebarNavItem",
        name: "Candidate Pool",
        to: "/dashboard/cdd-pool",
        icon: "cil-people",
      },
      {
        _name: "CSidebarNavItem",
        name: "Placement History",
        to: "/dashboard/placement-history",
        icon: "cil-history",
      },
      {
        _name: "CSidebarNavItem",
        name: "Help",
        to: "/dashboard/help",
        icon: "cil-chat-bubble",
      },
    ],
  },
];
